import {useEffect, useState} from 'react';
import cn from 'classnames';
import {BottomSheet} from 'react-spring-bottom-sheet';

import Accordion from '../../../../components/mazraeKit/accordion';
import Checkbox from '../../../../components/checkbox';
import {IFiltersData, buyersFiltersData} from './utils';
import CategoryCards from '../../../../module/newShop/home/inputGroups';
import {useBuyersListingFilters} from '../../../../hooks/filters/useBuyersListingFilter';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
  code: number;
}
export interface IFilters {
  categories: Array<IFiltersKeyValuePairs>;
  sorting: string;
  has_immediate: boolean;
}
const BuyerListingBottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
}: {
  openBottomSheet: boolean;
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {setBuyersFilters, buyersReset, buyersFilters} =
    useBuyersListingFilters();
  const [openAccordion, setOpenAccordion] = useState<boolean>(false);

  const [filters, setFilters] = useState<IFilters>({
    categories: buyersFilters.input_guid,
    sorting: buyersFilters.order_by || 'lastest',
    has_immediate: buyersFilters.has_immediate,
  });

  const sortingHandler = (sortingItem: IFiltersData) => {
    setFilters(prev => {
      return {...prev, sorting: sortingItem.value};
    });
  };

  const checkBoxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => {
      return {...prev, [event.target.name]: event.target.checked};
    });
  };

  useEffect(() => {
    setFilters({
      categories: buyersFilters.input_guid,
      sorting: buyersFilters.order_by,
      has_immediate: buyersFilters.has_immediate,
    });
  }, [buyersFilters]);

  return (
    <>
      <BottomSheet
        onDismiss={() => {
          setOpenBottomSheet(false);
        }}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
        className="transition ease-in-out delay-250"
      >
        <div className="pt-2 pb-3">
          <div className="flex justify-between px-3 border-b">
            <p className="font-Medium">فیلتر</p>
            <i
              className="text-xl icon-nameClose-remove"
              onClick={() => setOpenBottomSheet(false)}
            />
          </div>
          <div className="px-3 mt-3 mb-4">
            <span className="text-sm">دسته بندی</span>
          </div>
          <CategoryCards filters={filters} setFilters={setFilters} />

          <div className="flex items-center px-3 border-b">
            <Accordion
              accordionTitle="مرتب سازی بر اساس"
              setOpenAccordion={setOpenAccordion}
              openAccordion={openAccordion}
            >
              <div className="flex gap-2 pb-3">
                {buyersFiltersData.map(item => {
                  return (
                    <div
                      key={item.id}
                      className={cn(
                        'border-[1px] text-sm text-farm-shop-500 rounded-full border-farm-shop-500 w-fit py-2 px-2',
                        {
                          'bg-farm-shop-100': item.value === filters.sorting,
                        },
                      )}
                      onClick={() => sortingHandler(item)}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
            </Accordion>
          </div>
          <div className="flex flex-col gap-3 px-3 mt-4">
            <Checkbox
              label="آگهی‌های فوری"
              labelCustomClass="text-sm"
              name="has_immediate"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                checkBoxHandler(e)
              }
              defaultChecked={buyersFilters.has_immediate}
            />
          </div>
          <div className="flex flex-1 gap-2 px-3 mt-6">
            <button
              className="flex justify-center items-center w-3/5 rounded text-white py-2.5 bg-farm-shop-500"
              onClick={() => {
                setBuyersFilters({
                  has_immediate: filters.has_immediate,
                  order_by: filters.sorting,
                  input_guid: filters.categories,
                });
                setOpenBottomSheet(false);
              }}
            >
              اعمال فیلترها
            </button>
            <button
              className="flex justify-center items-center w-2/5 rounded py-2.5 border-[1px] text-red-500 !border-red-500"
              onClick={() => {
                buyersReset();
                setOpenBottomSheet(false);
              }}
            >
              حذف فیلترها
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default BuyerListingBottomSheet;
